import { render, staticRenderFns } from "./ActivateResourcesConfirmationModal.vue?vue&type=template&id=6d097431&scoped=true&"
import script from "./ActivateResourcesConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ActivateResourcesConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./ActivateResourcesConfirmationModal.vue?vue&type=style&index=0&id=6d097431&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d097431",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d097431')) {
      api.createRecord('6d097431', component.options)
    } else {
      api.reload('6d097431', component.options)
    }
    module.hot.accept("./ActivateResourcesConfirmationModal.vue?vue&type=template&id=6d097431&scoped=true&", function () {
      api.rerender('6d097431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ActivateResourcesConfirmationModal.vue"
export default component.exports